import { render, staticRenderFns } from "./SideNavItem.vue?vue&type=template&id=4f32d165&scoped=true&"
import script from "./SideNavItem.vue?vue&type=script&lang=js&"
export * from "./SideNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SideNavItem.vue?vue&type=style&index=0&id=4f32d165&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f32d165",
  null
  
)

export default component.exports